module.exports = __webpack_public_path__ + "static/media/calendar-2.ac18cc30.svg";